/**
 * Best Cursors - Bloom of Custom Cursors
 *
 * Exposes three web-accessible resources — options.html and two copies of its
 * vendor-named logo (bc-logo192.png and icons/bc-logo192.png) — to every origin with no
 * `use_dynamic_url`. The logo is an image, so it loads through `probeImage` with no CORS
 * grant and survives a strict page CSP, and its `bc-` prefix is distinctive.
 *
 * Manifest verified against version 1.0.8.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'pnpapokldhgeofbkljienpjofgjkafkm';

export const bestCursors: ExtensionDefinition = {
  id: ID,
  name: 'Best Cursors - Bloom of Custom Cursors',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 20_000,
  notes:
    'Three static WAR exposed to every origin with no dynamic URL. The bc-prefixed ' +
    'logo PNG loads without a CORS grant and is conclusive.',
  signals: [
    {
      id: 'war-bc-logo192',
      kind: 'web-accessible-resource',
      description:
        'Load bc-logo192.png via <img> — the vendor-named logo exposed to every origin; ' +
        'needs no CORS grant.',
      weight: 1,
      run: () => probeImage(ID, 'bc-logo192.png'),
    },
    {
      id: 'war-icons-bc-logo192',
      kind: 'web-accessible-resource',
      description:
        'Load icons/bc-logo192.png via <img> — the second copy of the logo, corroborating.',
      weight: 0.5,
      run: () => probeImage(ID, 'icons/bc-logo192.png'),
    },
    {
      id: 'war-options-html',
      kind: 'web-accessible-resource',
      description: 'Fetch options.html — the options page, an independent third path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'options.html'),
    },
  ],
};
